import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import styles from './../../Assets/CSS/Style.module.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL, BASE_FILE_URL } from './../../Environment';
import { toast } from 'react-toastify';
  
function Home() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [ads, setAds] = useState([]);
    const [categories, setCategories] = useState([]);
    
    const [topAds, setTopAds] = useState([]);
    const [bottomAds, setBottomAds] = useState([]);
    const [leftAds, setLeftAds] = useState([]);
    const [centerAds, setCenterAds] = useState([]);
    const [rightAds, setRightAds] = useState([]);
    
    const [topIndex, setTopIndex] = useState(0);
    const [bottomIndex, setBottomIndex] = useState(0);
    const [leftIndex, setLeftIndex] = useState(0);
    const [centerIndex, setCenterIndex] = useState(0);
    const [rightIndex, setRightIndex] = useState(0);

    useEffect(() => {
        document.title = 'Infomart | Agent Home';
        setIsLoading(true);  
        
        axios.get(`${BASE_URL}/ads`, {
            headers: {  
                'Content-Type': 'application/json' 
            } 
        }).then((res) => {
            const allAds = res.data.data;
            setAds(allAds);
            
            const homeAds = allAds.filter(ad => ad.page === 'Home');
            
            setTopAds(homeAds.filter(ad => ad.position === 'Top'));
            setBottomAds(homeAds.filter(ad => ad.position === 'Bottom'));
            setLeftAds(homeAds.filter(ad => ad.position === 'Left'));
            setCenterAds(homeAds.filter(ad => ad.position === 'Center'));
            setRightAds(homeAds.filter(ad => ad.position === 'Right'));
            
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
        
        axios.get(`${BASE_URL}/video-category`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setCategories(res.data.data);
        }).catch((error) => {
            console.error('Error fetching categories:', error);
        });
    }, []);
    
    useEffect(() => {
        const interval = setInterval(() => {
            if (topAds.length > 1) {
                setTopIndex((prev) => (prev + 1) % topAds.length);
            }
            if (bottomAds.length > 1) {
                setBottomIndex((prev) => (prev + 1) % bottomAds.length);
            }
            if (leftAds.length > 1) {
                setLeftIndex((prev) => (prev + 1) % leftAds.length);
            }
            if (centerAds.length > 1) {
                setCenterIndex((prev) => (prev + 1) % centerAds.length);
            }
            if (rightAds.length > 1) {
                setRightIndex((prev) => (prev + 1) % rightAds.length);
            }
        }, 4000);
        
        return () => clearInterval(interval);
    }, [topAds, bottomAds, leftAds, centerAds, rightAds]);

    const handleMenu = (slug) => {
        navigate(`/video/${slug}`); 
    } 
    
    return (
        <div className="app">    
            <div className="outlet">
                <div className="homeLayout"> 
                    <Sidebar />  
                    <div className={styles.home_container}>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))',
                            gap: '12px',
                            width: '100%',
                            marginBottom: '16px',
                        }}>
                            {categories.slice(0, 7).map((category, index) => {
                                const colorPalette = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B500', '#52BE80', '#EC7063', '#AF7AC5', '#5DADE2', '#48C9B0'];
                                const bgColor = colorPalette[index % colorPalette.length];
                                return (
                                    <div
                                        key={category.id || index}
                                        onClick={() => handleMenu(category.slug)}
                                        style={{
                                            backgroundColor: bgColor + '1A',
                                            borderRadius: '12px',
                                            padding: '14px 8px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'transform 0.2s, box-shadow 0.2s',
                                            border: `1px solid ${bgColor}30`,
                                            minHeight: '110px',
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-3px)';
                                            e.currentTarget.style.boxShadow = `0 6px 16px ${bgColor}40`;
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = 'none';
                                        }}
                                    >
                                        <div style={{
                                            width: '48px',
                                            height: '48px',
                                            borderRadius: '14px',
                                            backgroundColor: bgColor,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginBottom: '8px',
                                            overflow: 'hidden',
                                        }}>
                                            {category.icon ? (
                                                <img
                                                    src={BASE_FILE_URL + category.icon}
                                                    alt={category.name}
                                                    style={{
                                                        width: '28px',
                                                        height: '28px',
                                                        objectFit: 'contain',
                                                        filter: 'brightness(0) invert(1)',
                                                    }}
                                                />
                                            ) : (
                                                <span style={{ fontSize: '22px' }}>🎬</span>
                                            )}
                                        </div>
                                        <span style={{
                                            fontSize: '12px',
                                            fontWeight: '600',
                                            color: '#333',
                                            textAlign: 'center',
                                            lineHeight: '1.2',
                                            wordBreak: 'break-word',
                                        }}>
                                            {category.name}
                                        </span>
                                    </div>
                                );
                            })}
                            {categories.length > 8 && (
                                <div
                                    onClick={() => navigate('/video-categories')}
                                    style={{
                                        backgroundColor: '#1e90ff1A',
                                        borderRadius: '12px',
                                        padding: '14px 8px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        transition: 'transform 0.2s, box-shadow 0.2s',
                                        border: '1px solid #1e90ff30',
                                        minHeight: '110px',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-3px)';
                                        e.currentTarget.style.boxShadow = '0 6px 16px #1e90ff40';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <div style={{
                                        width: '48px',
                                        height: '48px',
                                        borderRadius: '14px',
                                        backgroundColor: '#1e90ff',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        marginBottom: '8px',
                                    }}>
                                        <span style={{ fontSize: '22px', color: 'white' }}>→</span>
                                    </div>
                                    <span style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#1e90ff',
                                        textAlign: 'center',
                                    }}>
                                        View All
                                    </span>
                                </div>
                            )}
                        </div>  
                        {isLoading ?
                            <h5 className="text-center mt-5">Loading...</h5>
                        :
                            <div className={styles.banners}>
                                <div className={styles.bannerMiddleContainer}>
                                    {/* <img src={BASE_FILE_URL + (leftAds[leftIndex]?.image || ads[0]?.image)} className={styles.wideBanner} /> */}
                                </div>   
                                <div className={styles.grid_middle}>
                                    <div className={styles.bannerTopContainer}>
                                        <img src={BASE_FILE_URL + (topAds[topIndex]?.image || ads[1]?.image)} className={styles.bannerTopContainer} />
                                    </div>  
                                    <div className={styles.bannerMiddleContainer}>
                                        <img src={BASE_FILE_URL + (centerAds[centerIndex]?.image || ads[3]?.image)} className={styles.wideBanner} />
                                    </div>
                                    <div className={styles.bannerTopContainer}>
                                        <img src={BASE_FILE_URL + (bottomAds[bottomIndex]?.image || ads[2]?.image)} className={styles.longbanner} />
                                    </div> 
                                </div> 
                                <div className={styles.bannerMiddleContainer}>
                                    {/* <img src={BASE_FILE_URL + (rightAds[rightIndex]?.image || ads[4]?.image)} className={styles.wideBanner} /> */}
                                </div>   
                            </div> 
                        } 
                    </div> 
                </div>
             </div> 
         </div>
    );
}

export default Home; 